import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userPlanQueryOptions } from "../queries/payment/userPlan";
import { apiSubscriptionQueryOptions } from "../queries/payment/apiSubscription";
import { api } from "../http";

export function useBuyPlan(config: {
  id: string;
  period: "yearly" | "monthly";
  coupon?: string;
}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["buyPlan", config.id],
    mutationFn: async () => {
      const searchParams = new URLSearchParams({
        subscription_type: config.period,
      });

      return await api.payment
        .post(`v1/payments/plan-checkout-session/${config.id}`, {
          searchParams,
        })
        .json<{ checkout_url: string }>();
    },
    onSuccess({ checkout_url }) {
      void queryClient.invalidateQueries({
        queryKey: userPlanQueryOptions.queryKey,
      });
      window.location.href = checkout_url;
    },
  });
}

export function useCancelSubscription() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["cancelSubscription"],
    mutationFn: async () => {
      return await api.payment
        .post("v1/api-services/subscriptions/cancel")
        .json();
    },
    onSuccess() {
      void queryClient.invalidateQueries({
        queryKey: apiSubscriptionQueryOptions.queryKey,
      });
    },
  });
}
